export { default } from './RichTextCard';
